import { render, staticRenderFns } from "./addIntegralShopRule.vue?vue&type=template&id=1a1d0a66"
import script from "./addIntegralShopRule.vue?vue&type=script&lang=js"
export * from "./addIntegralShopRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports